import { useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export function ScrollProgress() {
  const progress = useMotionValue(0);
  const scaleX = useSpring(progress, { stiffness: 200, damping: 30 });
  const docHeightRef = useRef(0);

  useEffect(() => {
    const measure = () => {
      const doc = document.documentElement;
      docHeightRef.current = Math.max(doc.scrollHeight - doc.clientHeight, 1);
    };
    measure();

    let ticking = false;
    const update = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        progress.set(Math.min(window.scrollY / docHeightRef.current, 1));
        ticking = false;
      });
    };

    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", measure, { passive: true });
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", measure);
    };
  }, [progress]);

  return (
    <motion.div
      style={{ scaleX, willChange: "transform" }}
      className="fixed top-0 left-0 right-0 h-[2px] bg-foreground/40 origin-left z-[60]"
    />
  );
}
